import { useSelector } from 'react-redux';

import { getObjectInfo } from '../../selectors/objectInfo';
import { EmptyListQuestions } from '../../components/EmptyListQuestions';

export const EmptyListQuestionsContainer = () => {
  const { objectName } = useSelector(getObjectInfo);

  return <EmptyListQuestions newbuildingName={objectName} />;
};
